import { render, staticRenderFns } from "./invoicemultiple.vue?vue&type=template&id=0afa8938&scoped=true&"
import script from "./invoicemultiple.vue?vue&type=script&lang=js&"
export * from "./invoicemultiple.vue?vue&type=script&lang=js&"
import style0 from "./invoicemultiple.vue?vue&type=style&index=0&id=0afa8938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa8938",
  null
  
)

export default component.exports